/* eslint-disable react/prop-types */
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { onLangTranslationUpdates } from "services";
import { updateLang } from "i18n";
import  {getTranslationsSuccess}  from "redux/actions/translationAction";

const TranslationProvider = (props) => {
  const dispatch = useDispatch();
  
  const {version}=useSelector((state)=>state.translation.i18n)
  

//Logic for updating translations
  useEffect(() => {
    try {
      if (version && version>1) {
        updateLang();
      }
    } catch (e) {
      console.log("Error in redux appConfig", e);
    }
  }, [version]);

  useEffect(() => {
    onLangTranslationUpdates(async (data) => {
      try {
        if (data) {
          dispatch(getTranslationsSuccess(data));
          updateLang();
        }
      } catch (e) {
        console.log("Error in fetching Translations Data", e);
      }
    });
  }, []);


  return <>{props.children}</>;
};

export default TranslationProvider;
